export default __webpack_public_path__ + "static/media/danflix.91c04dd7.png";